import { ActionType } from "../model/enum/ActionType";
import { ActionTemplate } from "../model/templates/ActionTemplate";

export const sortActionsByType = (actions: ActionTemplate[]): ActionTemplate[] => {
  const actionTypes = Object.values(ActionType);
  return actions.sort((a, b) => actionTypes.indexOf(a.type) - actionTypes.indexOf(b.type));
};
